
import downloadFile from '@/utils/downloadFile'

const paramsTransformer = ({
  dateFrom, dateTo, supervisors = [], acos = [], customers = [], zones = [], jobTypes = [], processes = []
}) => (
  {
    date_to: dateTo,
    date_from: dateFrom,
    supervisors: supervisors.length ? supervisors.join(',') : undefined,
    acos: acos.length ? acos.join(',') : undefined,
    zones: zones.length ? zones.join(',') : undefined,
    customers: customers.length ? customers.join(',') : undefined,
    job_types: jobTypes.length ? jobTypes.join(',') : undefined,
    processes: processes.length ? processes.join(',') : undefined
  }
)

/**
 * Get CSV Macro report
 * @return {Promise} An http GET request
 */
const fetchSinisters = (filters = {}) => {
  const transformedParams = paramsTransformer(filters)

  const config = {
    params: {
      ...transformedParams
    }
  }
  const filename = `Macro.csv`
  return downloadFile(`sinister/csv/macro_process/`, filename, { config })
}

export default fetchSinisters
